export const LIVE_AUCTIONEERS_SUPPORT_EMAIL = 'info@liveauctioneers.com';
export const LIVE_AUCTIONEERS_PACKAGING_EMAIL = 'packaging@liveauctioneers.com';
